<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <leads-tabs></leads-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <individual-sidebar></individual-sidebar>

            <div class="col-xl-9 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Organization </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <label class="col-form-label">Department</label>
                              <a
                                href="#"
                                class="label-add"
                                data-bs-toggle="modal"
                                data-bs-target="#add_project"
                                ><i class="ti ti-square-rounded-plus"></i>Add
                                New</a
                              >
                            </div>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <label class="col-form-label">Designation</label>
                              <a
                                href="#"
                                class="label-add"
                                data-bs-toggle="modal"
                                data-bs-target="#add_project"
                                ><i class="ti ti-square-rounded-plus"></i>Add
                                New</a
                              >
                            </div>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Income Range</label>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <label class="col-form-label"
                                >Industry Type</label
                              >
                              <a
                                href="#"
                                class="label-add"
                                data-bs-toggle="modal"
                                data-bs-target="#add_project"
                                ><i class="ti ti-square-rounded-plus"></i>Add
                                New</a
                              >
                            </div>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Address </label>
                            <input type="text" class="form-control">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Country</label>
                            
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Division </label>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">District</label>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Thana</label>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Zip/Po</label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Organization Website </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-control-label">Latitude</label>
                            <input type="number" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Longitude</label>
                            <input type="number" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <label class="col-form-label"
                                >Phone </label
                              >
                              <a
                                href="#"
                                class="label-add"
                                data-bs-toggle="modal"
                                data-bs-target="#add_project"
                                ><i class="ti ti-square-rounded-plus"></i>Add
                                New</a
                              >
                            </div>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Skype </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <label class="col-form-label"
                                >Social Network </label
                              >
                              <a
                                href="#"
                                class="label-add"
                                data-bs-toggle="modal"
                                data-bs-target="#add_project"
                                ><i class="ti ti-square-rounded-plus"></i>Add
                                New</a
                              >
                            </div>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                    <div class="btn-list">
                      <button type="submit" class="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- /Add New View -->

  <!-- Add New View -->
  <div class="modal custom-modal fade" id="add_project" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add New</h5>
          <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <form action="#">
            <div class="mb-3">
              <label class="col-form-label">Name</label>
              <input type="text" class="form-control" />
            </div>
            <div class="modal-btn text-end">
              <a href="#" class="btn btn-light" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button type="submit" class="btn btn-danger">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add New View -->
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Service Information",
      selectedProject: {},
      projects: [
        { id: 1, name: "Project 1" },
        { id: 2, name: "Project 2" },
        { id: 3, name: "Project 3" },
      ],
      selectedAssignTo: {},
      assignPersons: [
        { id: 1, name: "Assign To 1" },
        { id: 2, name: "Assign To 2" },
        { id: 3, name: "Assign To 3" },
      ],
      selectedAdditionalAssignTo: {},
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
